import { useMutation } from '@tanstack/react-query';

import { InterrogationStatus, useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api/src/common/queryFunction';

type BulkUpdateThicknessRequestBody = {
  inputs: { partFileUuid: string; thickness: number }[];
};

export type BulkUpdateThicknessResponseBody = {
  status: InterrogationStatus;
  componentIds: number[];
  quoteItemIds: number[];
}[];

export const useBulkUpdateThickness: MutationFunction<
  BulkUpdateThicknessResponseBody,
  BulkUpdateThicknessRequestBody
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useMutation({
    mutationFn: (requestBody) => {
      return request<BulkUpdateThicknessResponseBody>(
        `/parts/files/bulk_update_thickness`,
        {
          init: {
            method: 'POST',
            body: requestBody,
          },
        },
      );
    },
    ...queryOptions,
    mutationKey: ['bulkUpdateThickness'],
  });
};
